// Libraries
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { rem } from 'polished';

// Components
import Modal from '../../index';
import TeamSideInfo from './team-side-info';
import MyTeamCard from '../../../../../pages/profile/my-team/my-team-card';
import { ContentSpinner } from '../../../../ui/layout/spinner/index';

// REDUX: Actions
import { modalActions } from '~/redux/actions/modal-actions';

// Data Services
import ProfileServices from '../../../../../data/services/profiles-services';

let afterClose;

/**
 *  A Modal that warns the user that there is already an active alert in a specific area.
 *
 * @class TeamDetailModal
 * @extends {Component}
 */
class TeamDetailModal extends PureComponent {
	constructor(props) {
		super(props);
		this.onClose = this.onClose.bind(this);

		this.state = {
			myTeam: [],
			teamName: null,
			numberOfMembers: 0,
			distance: 0,
			ranking: 0,
		};
	}

	componentDidMount() {
		this.fetchTeamDetails(this.props.teamId, this.props.challengeId);
		this.setState({
			teamName: this.props.teamName,
			numberOfMembers: this.props.numberOfMembers,
			distance: this.props.distance,
			ranking: this.props.ranking,
		});
	}

	/**
	 * Fetches the list of details from a team
	 *
	 * @param {*} teamId
	 * @param {*} challengeId
	 * @memberof TeamDetailModal
	 */
	fetchTeamDetails(teamId, challengeId) {
		ProfileServices.getTeamDetails(teamId, challengeId)
			.then(response => {
				// The response comes positive if the users profile data is returned
				if (response.data) {
					this.setState({
						myTeam: response.data,
					});
				} else {
					console.info('response status: ', response.status);
				}
			})
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 400) {
					return console.error('Response is invalid');
				} else {
					console.error('Error returning the list of team details');
				}
			});
	}

	/**
	 * Closes the window, when the user clicks on the 'cancel' button
	 *
	 * @memberof TeamDetailModal
	 */
	onClose() {
		modalActions.hideModal();
		this.props.dispatch(modalActions.hideModal());

		if (afterClose) {
			afterClose();
		}
	}

	/**
	 * Renders the list of team members
	 *
	 * @param {*} team
	 * @returns
	 * @memberof MyTeam
	 */
	renderTeamList(team) {
		if (team && team.length > 0) {
			return (
				<React.Fragment>
					{team.map((item, index) => (
						<MyTeamCard
							className="large-6 small-6"
							key={index}
							isCaptain={item.captain}
							distance={item.distance ? item.distance : 0}
							isUser={item.id ? true : false}
							isRequired={index > 0 && index < 4 ? true : false}
							photo={item.photoUrl}
							name={item.nick}
						/>
					))}
				</React.Fragment>
			);
		} else {
			return <ContentSpinner />;
		}
	}

	render() {
		const { onClose } = this.props;
		const { myTeam } = this.state;

		return (
			<Modal
				modalTitle={`${this.state.teamName}`}
				modalSubtitle={`${this.state.numberOfMembers} member(s)`}
				onClose={onClose}
				large
			>
				<Wrapper className="grid-x grid-margin-x">
					<TeamSideInfo
						className="large-3 small-12"
						nick={`${this.state.teamName}`}
						distance={this.state.distance / 1000}
						position={this.state.ranking}
						float={true}
					/>

					<main className="cell large-9 small-12">
						<ul className="my-team-form__members grid-x grid-margin-x">{this.renderTeamList(myTeam)}</ul>
					</main>
				</Wrapper>
			</Modal>
		);
	}
}

function mapStateToProps(state) {
	return {
		modalTitle: state.modal.properties.modalTitle,
		teamId: state.modal.properties.teamId,
		challengeId: state.modal.properties.challengeId,
		teamName: state.modal.properties.teamName,
		numberOfMembers: state.modal.properties.numberOfMembers,
		distance: state.modal.properties.distance,
		ranking: state.modal.properties.ranking,
	};
}

TeamDetailModal.defaultProps = {
	modalTitle: '',
};

TeamDetailModal.propTypes = {
	modalTitle: PropTypes.string,
	onClose: PropTypes.func,
};

export default connect(mapStateToProps)(TeamDetailModal);

/////////////////////////
//  Styled Components //
/////////////////////////
const Wrapper = styled.div`
	min-height: 50vh;
	height: auto;
	max-height: 80vh;
	overflow-y: auto;

	@media ${props => props.theme.breakpointLarge} {
		max-height: ${rem('520px')};
	}

	@media ${props => props.theme.breakpointHd} {
		max-height: ${rem('640px')};
	}
`;



// WEBPACK FOOTER //
// ./src/components/general/modal/types/team-detail/index.jsx